import Index from '../../pages/snail/riverMountain/index'

const base = 'riverMountain';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/snail/riverMountain.js